// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","bannerContainer":"App_bannerContainer__Wga2r","menu":"App_menu__M8k5S","footerText":"App_footerText__vkiMt","nextPage":"App_nextPage__PT27Y"};